import {useCallback} from 'react';

import storage from 'store/localStorage';

const version = storage.getItem('version');

// Fabric v5/v6 → v7 type name mapping
const TYPE_MAP = {
    'text': 'Text',
    'i-text': 'IText',
    'textbox': 'Textbox',
    'group': 'Group',
    'circle': 'Circle',
    'rect': 'Rect',
    'path': 'Path',
    'image': 'Image',
    'line': 'Line',
    'polygon': 'Polygon',
    'polyline': 'Polyline',
    'triangle': 'Triangle',
    'ellipse': 'Ellipse',
    'activeSelection': 'ActiveSelection',
    'activeselection': 'ActiveSelection',
};

const migrateType = (obj) => {
    if (!obj) return;

    if (obj.type && TYPE_MAP[obj.type]) {
        obj.type = TYPE_MAP[obj.type];
    }

    if (obj.objects && Array.isArray(obj.objects)) {
        obj.objects.forEach(migrateType);
    }
};

const useMigration6to7 = () => {
    return useCallback(() => {
        if (version >= 7) {
            console.log('Migration6to7: already migrated to version 7');
            return;
        }

        console.log('Migration6to7: migrating to version 7 (Fabric.js v7 type names)');

        const sheetsData = storage.getItem('sheets');
        if (sheetsData && Array.isArray(sheetsData)) {
            sheetsData.forEach(sheet => {
                const sheetKey = `sheet_${sheet.id}`;
                const sheetData = storage.getItem(sheetKey);

                if (sheetData && sheetData.canvas && sheetData.canvas.objects) {
                    sheetData.canvas.objects.forEach(migrateType);
                    storage.setItem(sheetKey, sheetData);
                }
            });
        }

        storage.setItem('version', 7);
        console.log('Migration6to7: completed');
    }, []);
};

export default useMigration6to7;
